import Modal, { ModalProps } from "antd/lib/modal";
import React, { useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "./SettingsModal.scss";
import SettingsDrawerContent from "./SettingsDrawerContent";
import "./PublishPageMenu.scss";
import { connect } from "react-redux";
import { UserState } from "../../store/user/types";
import { setIsSettingsModalVisible } from "../../store/user/actions";
import classNames from "classnames";

interface Props extends ModalProps, RouteComponentProps {
  user: UserState;
  saveWebsiteDataInStore: any;
  saveWebsitePageDataInStore: any;
  publishPage: any;
  saveImageInfoInDB: any;
  removeImageFromDB: any;
  saveBlogDataInStore: any;
  saveBlogPostDataInStore: any;
  publishPost: any;
  type: string;
  setSettingsModalType: (type: string) => void;
  setIsSettingsModalVisible: (visible: boolean) => void;
}
const SettingsModal = (props: Props) => {
  const { setSettingsModalType } = props;
  const [isWide, setIsWide] = useState(false);

  useEffect(() => {
    if (props.user.settings) {
      setSettingsModalType("website");
      props.setIsSettingsModalVisible(true);
    }
  }, [props.user.settings]);

  const onCancel = () => {
    props.setIsSettingsModalVisible(false);
  };

  return (
    <Modal
      className={classNames(`settings-modal ${props.type}`, {
        "is-wide": isWide,
      })}
      centered
      visible={props.user.isSettingsModalVisible}
      onCancel={onCancel}
      footer={null}
      width={"100%"}
      zIndex={1030}
      destroyOnClose
      transitionName=""
    >
      <SettingsDrawerContent
        type={props.type as any}
        history={props.history}
        saveWebsiteDataInStore={props.saveWebsiteDataInStore}
        saveWebsitePageDataInStore={props.saveWebsitePageDataInStore}
        publishPage={props.publishPage}
        saveImageInfoInDB={props.saveImageInfoInDB}
        removeImageFromDB={props.removeImageFromDB}
        saveBlogDataInStore={props.saveBlogDataInStore}
        saveBlogPostDataInStore={props.saveBlogPostDataInStore}
        publishPost={props.publishPost}
        setDrawerWidth={() => {}}
        setIsWide={setIsWide}
      />
    </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, { setIsSettingsModalVisible })(
  withRouter(SettingsModal)
);
